/* Site-wide, last-touch Ads attribution for lead forms, plus the existing
   utm_source cart attribute for Shopify order "Additional details". */
(function () {
  // Capture the whole visit before any redirect or URL cleanup. Do not merge
  // tagged visits: e.g. PMax without a keyword must clear an earlier Search term.
  var FIELDS = [
    'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content',
    'campaign_id', 'match_type', 'gclid', 'gbraid', 'wbraid'
  ];
  var ATTRIBUTION_KEY = 'lhfp_ads_attribution';
  var attribution = {};
  var params;
  try {
    params = new URLSearchParams(window.location.search);
    var tagged = FIELDS.some(function (key) { return params.has(key); });
    if (tagged) {
      FIELDS.forEach(function (key) { attribution[key] = params.get(key) || ''; });
      try { sessionStorage.setItem(ATTRIBUTION_KEY, JSON.stringify(attribution)); } catch (e) {}
    } else {
      try { attribution = JSON.parse(sessionStorage.getItem(ATTRIBUTION_KEY)) || {}; } catch (e) {}
    }
  } catch (e) {} // Tracking/storage failures must never prevent a lead submission.

  // Return a fresh, complete snapshot; keep decoded campaign/keyword values exact.
  // If storage is blocked, the current page still retains attribution in memory.
  window.lhfpAttribution = {
    get: function () {
      var result = {};
      FIELDS.forEach(function (key) {
        result[key] = typeof attribution[key] === 'string' ? attribution[key] : '';
      });
      return result;
    }
  };

  var STORE_KEY = 'lhfp_utm_source';   // persisted value (localStorage)
  var WRITTEN_KEY = 'lhfp_utm_written'; // value already pushed to cart this session

  var val = '';
  try {
    val = new URLSearchParams(window.location.search).get('utm_source') || '';
  } catch (e) { return; } // very old browser without URLSearchParams — bail quietly

  val = String(val).trim().slice(0, 200); // sanitize + cap length

  // Last-touch: a fresh utm_source in the URL overwrites the stored one;
  // otherwise fall back to whatever was captured on an earlier page.
  if (val) {
    try { localStorage.setItem(STORE_KEY, val); } catch (e) {}
  } else {
    try { val = localStorage.getItem(STORE_KEY) || ''; } catch (e) {}
  }
  if (!val) return; // no utm_source now and none stored — nothing to do

  // Write at most once per session per value, so we don't POST on every page view.
  // A brand-new utm_source (different value) re-triggers the write.
  var already = '';
  try { already = sessionStorage.getItem(WRITTEN_KEY) || ''; } catch (e) {}
  if (already === val) return;

  fetch('/cart/update.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ attributes: { utm_source: val } })
  }).then(function () {
    try { sessionStorage.setItem(WRITTEN_KEY, val); } catch (e) {}
  })['catch'](function () {}); // never surface tracking errors to the shopper
})();
